import React from 'react';
import CardButton from '../CardButton/CardButton.jsx';
import './ProductCard.css';

const ProductCard = ({
  title,
  description,
  image,
  className = '',
  gridArea = '',
}) => {
  return (
    <div
      className={`product-card ${className} ${gridArea ? `product-card--area-${gridArea.toLowerCase()}` : ''}`}
    >
      <div className="product-card__header">
        <div className="product-card__icon">
          <svg
            viewBox="0 0 22 29"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
          >
            <path
              d="M11.0026 21.6654C11.7098 21.6654 12.3881 21.3844 12.8882 20.8843C13.3883 20.3842 13.6693 19.7059 13.6693 18.9987C13.6693 18.2915 13.3883 17.6132 12.8882 17.1131C12.3881 16.613 11.7098 16.332 11.0026 16.332C10.2954 16.332 9.61708 16.613 9.11699 17.1131C8.61689 17.6132 8.33594 18.2915 8.33594 18.9987C8.33594 19.7059 8.61689 20.3842 9.11699 20.8843C9.61708 21.3844 10.2954 21.6654 11.0026 21.6654ZM19.0026 9.66537C19.7099 9.66537 20.3881 9.94632 20.8882 10.4464C21.3883 10.9465 21.6693 11.6248 21.6693 12.332V25.6654C21.6693 26.3726 21.3883 27.0509 20.8882 27.551C20.3881 28.0511 19.7099 28.332 19.0026 28.332H3.0026C2.29536 28.332 1.61708 28.0511 1.11699 27.551C0.616889 27.0509 0.335938 26.3726 0.335938 25.6654V12.332C0.335938 11.6248 0.616889 10.9465 1.11699 10.4464C1.61708 9.94632 2.29536 9.66537 3.0026 9.66537H4.33594V6.9987C4.33594 5.23059 5.03832 3.5349 6.28856 2.28465C7.5388 1.03441 9.23449 0.332031 11.0026 0.332031C11.8781 0.332031 12.745 0.50447 13.5538 0.839501C14.3627 1.17453 15.0976 1.6656 15.7167 2.28465C16.3357 2.90371 16.8268 3.63864 17.1618 4.44747C17.4968 5.25631 17.6693 6.12322 17.6693 6.9987V9.66537H19.0026ZM11.0026 2.9987C9.94174 2.9987 8.92432 3.42013 8.17418 4.17027C7.42403 4.92042 7.0026 5.93783 7.0026 6.9987V9.66537H15.0026V6.9987C15.0026 5.93783 14.5812 4.92042 13.831 4.17027C13.0809 3.42013 12.0635 2.9987 11.0026 2.9987Z"
              fill="currentColor"
            />
            <path
              d="M14.0026 18.9987C14.0026 20.6556 12.6595 21.9987 11.0026 21.9987C9.34575 21.9987 8.0026 20.6556 8.0026 18.9987C8.0026 17.3418 9.34575 15.9987 11.0026 15.9987C12.6595 15.9987 14.0026 17.3418 14.0026 18.9987Z"
              fill="currentColor"
            />
          </svg>
        </div>
        <h3 className="product-card__title">{title}</h3>
      </div>

      {!!image && (
        <div className="product-card__content">
          <img
            src={image}
            alt={title}
            className="product-card__product-image"
          />
        </div>
      )}

      {!!description && (
        <div className="product-card__description-wrapper">
          <p className="product-card__description">{description}</p>
        </div>
      )}

      <CardButton />
    </div>
  );
};

export default ProductCard;
